import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66b89b71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkOrderDepartureDate" }
const _hoisted_2 = { class: "container__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_input = _resolveComponent("ok-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "OkOrderDepartureDate__container",
      style: _normalizeStyle(_ctx.widthFull ? 'max-width: none;' : '')
    }, [
      _createVNode(_component_ok_input, {
        name: _ctx.name,
        placeholder: "Например: 20.02.2024",
        type: "date",
        min: _ctx.min,
        value: _ctx.unformatDateStringFromApi(_ctx.value),
        disabled: _ctx.disabled,
        "is-invalid": _ctx.valueValidation.$error,
        "validation-errors": _ctx.valueValidation.$errors,
        onChange: _ctx.onDateChanged,
        required: _ctx.required
      }, null, 8, ["name", "min", "value", "disabled", "is-invalid", "validation-errors", "onChange", "required"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["buttons__button", [
                        {
                            'button--disabled': _ctx.disabled || _ctx.isTodayDisabled,
                            'button--active': _ctx.isDateEqualsToday(),
                        },
                        _ctx.type,
                    ]]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelectToday && _ctx.onSelectToday(...args)))
        }, " Сегодня ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["buttons__button", [
                        {
                            'button--disabled': _ctx.disabled,
                            'button--active': _ctx.isDateEqualsTomorrow(),
                        },
                        _ctx.type,
                    ]]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSelectTomorrow && _ctx.onSelectTomorrow(...args)))
        }, " Завтра ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["buttons__button", [
                        {
                            'button--disabled': _ctx.disabled,
                            'button--active': _ctx.isDateEqualsAfterTomorrow(),
                        },
                        _ctx.type,
                    ]]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSelectAfterTomorrow && _ctx.onSelectAfterTomorrow(...args)))
        }, " Послезавтра ", 2)
      ])
    ], 4)
  ]))
}